"use strict";

import angular from "angular";

export class NPSAssessmentsDialogCtrl {
    constructor($stateParams, $mdDialog, locals, $state) {
        this.$stateParams = $stateParams;
        this.$mdDialog = $mdDialog;
        this.locals = locals;

        this.ratings = locals.ratings;
        this.currentRating = {};
        this.accounting = locals.accounting;
        this.company = locals.company;
        this.scores = new Array(11);
    }

    $onInit() {
        this.selectHistory(this.locals.index || 0);
    }

    selectHistory(index = 0) {
        if (!this.ratings[index]) return;
        const current = this.ratings[index];
        const indications = current.props?.recommendations
            ? current.props.recommendations
                  .map((u) => u.name + " " + "<" + u.contact + ">")
                  .join("; ")
            : "";
        this.currentRating = {
            ...current.getProps(),
            userEmail: `${current.props?.name} <${current.props?.email}>`,
            indications
        };
    }

    getInitials(name) {
        return !name
            ? ""
            : name
                  .replace(/[^\w\s]/gi, "")
                  .split(" ")
                  .map((word, index, arr) =>
                      index == 0 || (arr.length > 1 && index == arr.length - 1)
                          ? word.charAt(0)
                          : ""
                  )
                  .join("")
                  .toUpperCase();
    }
}

angular.module("nucont.shared").controller("NPSAssessmentsDialogCtrl", [
        "$stateParams",
        "$mdDialog",
        "locals",

        NPSAssessmentsDialogCtrl
    ]);
